import EventController from "../event_controller";

export default class extends EventController {
  static targets = [
    "barcode",
    "ccLast4",
    "lastName",
    "licensePlateNumber",
    "licensePlateState",
    "phoneOrEmail",
  ];

  eventProperties(baseProperties, _eventType, node, _target) {
    return { ...baseProperties, ...this.#loginCredentials() };
  }

  // Only whether each credential was filled in reaches PostHog. The values are what a member logs in
  // with, and members type whole card numbers into the last-4 field, so they never leave the form.
  #loginCredentials() {
    const credentials = {};

    if (this.hasBarcodeTarget) {
      credentials.barcode_provided = this.#provided(this.barcodeTarget);
    }

    if (this.hasCcLast4Target) {
      credentials.cc_last_4_provided = this.#provided(this.ccLast4Target);
    }

    if (this.hasLastNameTarget) {
      credentials.last_name_provided = this.#provided(this.lastNameTarget);
    }

    if (this.hasLicensePlateNumberTarget) {
      credentials.license_plate_number_provided = this.#provided(this.licensePlateNumberTarget);
    }

    if (this.hasLicensePlateStateTarget) {
      credentials.license_plate_state = this.licensePlateStateTarget.value;
    }

    if (this.hasPhoneOrEmailTarget) {
      credentials.phone_or_email = this.phoneOrEmailTarget.value;
    }

    return { login_credentials: credentials };
  }

  #provided(target) {
    return target.value.trim() !== "";
  }
}
